<template>
  <span class="subtitle fs-2 m-4">{{ currentChartField === "opportunity" ? "Opportunity" : "Risk" }} assessment</span>
  <div id="risk-assessment" class="hello" ref="chartdiv"></div>
</template>

<script>
import * as am5 from "@amcharts/amcharts5";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import * as am5xy from "@amcharts/amcharts5/xy";
/* eslint-disable */
import globalVar from "@/assets/globalVar.json"

export default {
data() {
  return {
    selectedCountry: { id: '', value: '' },
    status: null
  }
},
props: {
  data_country: {
      type: Object,
      required: true,
  },
  currentChartField: {
    type: String,
    required: true,
  }
},
methods: {
  getStatusClass(status) {
    let rangesData =  [];
    if (this.currentChartField === "opportunity"){
      rangesData = globalVar.opport
    } else {
      rangesData = globalVar.risk
    }
    
    if (status < rangesData[0].rangeMax) {
      return `${rangesData[0].color}`
    } else if (status >= rangesData[1].rangeMin - 0.005  && status < rangesData[1].rangeMax - 0.005) {
      return `${rangesData[1].color}`
    } else if (status >= rangesData[2].rangeMin - 0.005  && status < rangesData[2].rangeMax - 0.005) {
      return `${rangesData[2].color}`
    } else if (status >= rangesData[3].rangeMin - 0.005  && status < rangesData[3].rangeMax - 0.005) {
      return `${rangesData[3].color}`
    } else {
      return `${rangesData[4].color}`
    }
  },


  GetCountry() {
      this.selectedCountry.id = this.data_country.name;
      if (this.currentChartField === "opportunity") {
        this.selectedCountry.value = this.data_country.opportunity.value;
        this.selectedCountry.value_str = this.data_country.opportunity.value !== null ? Math.round(this.data_country.opportunity.value * 100) / 100 : '';
      } else {
        this.selectedCountry.value = this.data_country.risk.value;
        this.selectedCountry.value_str = this.data_country.risk.value !== null ? Math.round(this.data_country.risk.value * 100) / 100 : '';
      }
      
  },
  renderChart() {
    let root = am5.Root.new(this.$refs.chartdiv);
    root.setThemes([
      am5themes_Animated.new(root)
    ]);
    let chart = root.container.children.push(am5xy.XYChart.new(root, {
      panX: false,
      panY: false,
      wheelX: "none",
      wheelY: "none",
      layout: root.verticalLayout,
      paddingRight: 30,
    }));
    let legend = chart.children.push(
      am5.Legend.new(root, {
      centerX: am5.p50,
      x: am5.p50
      })
    );

    let xAxis = chart.xAxes.push(am5xy.CategoryAxis.new(root, {
      categoryField: "category",
      renderer: am5xy.AxisRendererX.new(root, {
      }),
      tooltip: am5.Tooltip.new(root, {})
    }));

    let xRenderer = xAxis.get("renderer");

    xRenderer.grid.template.set("forceHidden", true);
    xRenderer.labels.template.set("forceHidden", true);

    let rangesDataRisk = globalVar.risk
    let rangesDataOpport = globalVar.opport
    let data = [
    {
      category: "1",
      value: 100,
      risk: this.selectedCountry.value_str,
      currentBullet: false,
      columnSettings: {
        fill: am5.color(
          this.currentChartField === "opportunity"
            ? (this.selectedCountry.value_str !== '' ? rangesDataOpport[0].color : '#999999')
            : (this.selectedCountry.value_str !== '' ? rangesDataRisk[0].color : '#999999')
        )
      }
    }, {
      category: "2",
      value: 100,
      risk: this.selectedCountry.value_str,
      currentBullet: false,
      columnSettings: {
        fill: am5.color(
          this.currentChartField === "opportunity"
            ? (this.selectedCountry.value_str !== '' ? rangesDataOpport[1].color : '#999999')
            : (this.selectedCountry.value_str !== '' ? rangesDataRisk[1].color : '#999999')
        )
      }
    }, {
      category: "3",
      value: 100,
      risk: this.selectedCountry.value_str,
      currentBullet: false,
      columnSettings: {
        fill: am5.color(
          this.currentChartField === "opportunity"
            ? (this.selectedCountry.value_str !== '' ? rangesDataOpport[2].color : '#999999')
            : (this.selectedCountry.value_str !== '' ? rangesDataRisk[2].color : '#999999')
        )
      }
    }, {
      category: "4",
      value: 100,
      risk: this.selectedCountry.value_str,
      currentBullet: false,
      columnSettings: {
        fill: am5.color(
          this.currentChartField === "opportunity"
            ? (this.selectedCountry.value_str !== '' ? rangesDataOpport[3].color : '#999999')
            : (this.selectedCountry.value_str !== '' ? rangesDataRisk[3].color : '#999999')
        )
      }
    }, {
      category: "5",
      value: 100,
      risk: this.selectedCountry.value_str,
      currentBullet: false,
      columnSettings: {
        fill: am5.color(
          this.currentChartField === "opportunity"
            ? (this.selectedCountry.value_str !== '' ? rangesDataOpport[4].color : '#999999')
            : (this.selectedCountry.value_str !== '' ? rangesDataRisk[4].color : '#999999')
        )
      } 
    }
  ];

  // let ranges = [];
  // let status = [];
  // if (this.currentChartField === "opportunity"){
  //   ranges = [1, 2.001, 2.5, 3, 4, 5];
  //   status = ["Low", "Moderately Low", "Moderately High", "High", "Very High"]
  // } else {
  //   ranges = [1, 2.001, 2.995, 3.5, 4, 5];
  //   status = ["Low", "Moderately Low", "Moderately High", "High", "Very High"]
  // }
  // let category = 1;

  // for (let i = 1; i < ranges.length; i++) {
  //   if (this.selectedCountry.value >= ranges[i - 1] && this.selectedCountry.value < ranges[i]) {
  //     category = i;
  //     this.status = status[i - 1]
  //     break;
  //   } else if (this.selectedCountry.value >= 5) {
  //     category = 5;
  //     this.status = status[4]
  //   }
  // }

  let rangesData = [];
  if (this.currentChartField === "opportunity"){
    rangesData = globalVar.opport
  } else {
    rangesData = globalVar.risk
  }

  let category = 1;
  if (this.selectedCountry.value >= 5) {
    category = 5;
    this.status = rangesData[4].indicator;
  } else {
    category = '#808080'
    for (let i = 0; i < rangesData.length; i++) {
      if(this.selectedCountry.value >= rangesData[i].rangeMin - 0.005 && this.selectedCountry.value <= rangesData[i].rangeMax - 0.005){
        category = i+1;
        this.status = rangesData[i].indicator;
        break;
      }
    }
  }

  data.forEach(item => {
    item.currentBullet = item.category == category;
  });
    xAxis.data.setAll(data);

    let yAxis = chart.yAxes.push(am5xy.ValueAxis.new(root, {
      min: 0,
      max: 400,
      strictMinMax: true,
      renderer: am5xy.AxisRendererY.new(root, {})
    }));

    let yRenderer = yAxis.get("renderer");

    yRenderer.grid.template.set("forceHidden", true);
    yRenderer.labels.template.set("forceHidden", true);

    let series = chart.series.push(am5xy.ColumnSeries.new(root, {
      xAxis: xAxis,
      yAxis: yAxis,
      valueYField: "value",
      categoryXField: "category",
      riskXField: "risk",
      maskBullets: false
    }));

    // let chartTitle = "";
    // if (this.currentChartField === "opportunity"){
    //   // chartTitle = "Opportunity Assessment"
    //   chartTitle = `<div class=\"fs-2 mt-2 text-center\" style=\"${this.getStatusClass(this.selectedCountry.value)};\">${this.status}</div>`
    // } else {
    //   // chartTitle = "Risk Assessment"
    //   chartTitle = `<div class=\"fs-2 mt-2 text-center\" style=\"${this.getStatusClass(this.selectedCountry.value)};\">${this.status}</div>`
    // }

    let chartTitleText = this.status; // plain text for the chart

    // Determine color dynamically using your function
    let chartTitleColor = this.getStatusClass(this.selectedCountry.value); // should return something like "#FF0000"

    chart.children.unshift(am5.Label.new(root, {
      text: chartTitleText,
      fill: am5.color(chartTitleColor),
      fontSize: 25,
      fontWeight: "500",
      textAlign: "center",
      x: am5.percent(50),
      centerX: am5.percent(50),
      paddingTop: 0,
      paddingBottom: 0
    }));

    series.columns.template.setAll({
      width: am5.p100,
      tooltipY: 0,
      strokeOpacity: 1,
      strokeWidth:2,
      stroke:am5.color(0xffffff),
      templateField: "columnSettings"
    });

    series.bullets.push((root, target, dataItem) => {
      if (dataItem.dataContext.currentBullet) {
        if (this.selectedCountry.value_str !== '') {
          
          let container = am5.Container.new(root, {});

          let pin = container.children.push(am5.Graphics.new(root, {
            fill: dataItem.dataContext.columnSettings.fill,
            dy: -5,
            centerY: am5.p100,
            centerX: am5.p50,
            svgPath: "M66.9 41.8c0-11.3-9.1-20.4-20.4-20.4-11.3 0-20.4 9.1-20.4 20.4 0 11.3 20.4 32.4 20.4 32.4s20.4-21.1 20.4-32.4zM37 41.4c0-5.2 4.3-9.5 9.5-9.5s9.5 4.2 9.5 9.5c0 5.2-4.2 9.5-9.5 9.5-5.2 0-9.5-4.3-9.5-9.5z"
          }));
          let textColor = am5.color("#ffffff");
          if (dataItem.dataContext.category == 5 || dataItem.dataContext.category == 4) {
            textColor = am5.color("#000000");
          }
          let label = container.children.push(am5.Label.new(root, {
            text: dataItem.dataContext.risk,
            dy: -38,
            centerY: am5.p50,
            centerX: am5.p50,
            populateText: true,
            paddingTop: 5,
            paddingRight: 5,
            paddingBottom: 5,
            paddingLeft: 5,
            fill: textColor,
            background: am5.RoundedRectangle.new(root, {
              fill: dataItem.dataContext.columnSettings.fill,
              cornerRadiusTL: 20,
              cornerRadiusTR: 20,
              cornerRadiusBR: 20,
              cornerRadiusBL: 20,
            })
          }));
          const interpolatePosition = (value) => {
            let rangemin = -75;
            let rangemax = 75;
            if (value <= 1) return rangemin;  // Start at -100% for risk 1
            if (value >= 5) return rangemax;  // End at 10% for risk 5

            let ranges = [
              { min: rangesData[0].rangeMin, max: rangesData[0].rangeMax},
              { min: rangesData[1].rangeMin, max: rangesData[1].rangeMax},
              { min: rangesData[2].rangeMin, max: rangesData[2].rangeMax},
              { min: rangesData[3].rangeMin, max: rangesData[3].rangeMax},
              { min: rangesData[4].rangeMin, max: rangesData[4].rangeMax}
            ];

            for (let range of ranges) {
              if (value > range.min && value <= range.max) {
                let ratio = (value - range.min) / (range.max - range.min);
                return rangemin + ratio * (rangemax - rangemin);
              }
            }
            return 0; // Default position
          };
          let position = interpolatePosition(dataItem.dataContext.risk);

          pin.setAll({ dy: -5 , dx: position });
          label.setAll({ dy: -38 , dx: position });

          return am5.Bullet.new(root, {
            locationY: 1,
            sprite: container
          });
        }
      } else if (dataItem.dataContext.targetBullet) {
        let container = am5.Container.new(root, {
          dx: 15
        });
        return am5.Bullet.new(root, {
          locationY: 0.5,
          sprite: container
        });
      }
      return false;
    }
  );

    series.data.setAll(data);

    function addAxisLabel(category, text) {
      let rangeDataItem = xAxis.makeDataItem({
        category: category
      });
  
      let range = xAxis.createAxisRange(rangeDataItem);

      range.get("label").setAll({
        text: text,
        forceHidden: false
      });

      range.get("grid").setAll({
        strokeOpacity: 1,
        location: 1
      });
    };

  addAxisLabel("1", "Negligible Risk");
  addAxisLabel("2", "");
  addAxisLabel("3", "");
  addAxisLabel("4", "");
  addAxisLabel("5", "Severe Risk");

  series.appear(1000, 100);
  chart.appear(1000, 100);
  }
},
mounted() {
  this.GetCountry()
  this.renderChart()
}
}
</script>

